import * as Rizhi from "@/api/rizhi";
export default {
  props: ["cao_id", "cao_show", "api"],
  data() {
    return {
      tableData: [],
      page: 1,
      total: 1,
      per_page: 10
    };
  },
  methods: {
    handleSizeChange(val) {
      this.per_page = val;
      this.open();
    },
    handleClose() {
      this.$parent.cao_show = false;
      this.$emit('update-cao-show', false); // 向父组件发送事件，通知其更新 `cao_show`
    },
    async open() {
      Rizhi[this.api]({
        record_id: this.cao_id,
        page: this.page,
        per_page: this.per_page
      }).then(res => {
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    chans(val) {
      this.page = val;
      this.open();
    }
  }
};